import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useUpdateSolicitudGastosOrtopediaByID = () => {
  const [loadingUpdateSolicitudGastosOrtopediaById, setLoadingUpdateSolicitudGastosOrtopediaById] = useState(false);
  const [successUpdateSolicitudGastosOrtopediaById, setSuccessUpdateSolicitudGastosOrtopediaById] = useState(false);
  const [errorUpdateSolicitudGastosOrtopediaById, setErrorUpdateSolicitudGastosOrtopediaById] = useState(null);
  const [dataUpdateSolicitudGastosOrtopediaById, setDataSolicitudGastosOrtopedia] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const updateSolicitudGastosOrtopediaById = async (
    userId: string,
    formId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingUpdateSolicitudGastosOrtopediaById(true);
    setSuccessUpdateSolicitudGastosOrtopediaById(false);
    setErrorUpdateSolicitudGastosOrtopediaById(null);

    try {
      const payload = {
        ...data,
        Id: data?.Id ?? formId,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.updateSolicitudGastosContingenciaProfesionalOrtopediaByID(userId, formId, payload);

      setSuccessUpdateSolicitudGastosOrtopediaById(true);
      setDataSolicitudGastosOrtopedia(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en updateSolicitudGastosOrtopediaById:", err);
      setErrorUpdateSolicitudGastosOrtopediaById(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingUpdateSolicitudGastosOrtopediaById(false);
    }
  };

  return {
    updateSolicitudGastosOrtopediaById,
    loadingUpdateSolicitudGastosOrtopediaById,
    successUpdateSolicitudGastosOrtopediaById,
    errorUpdateSolicitudGastosOrtopediaById,
    dataUpdateSolicitudGastosOrtopediaById
  };
};

export default useUpdateSolicitudGastosOrtopediaByID;
